import { render, staticRenderFns } from "./Firmas.vue?vue&type=template&id=8632ad4a"
import script from "./Firmas.vue?vue&type=script&lang=js"
export * from "./Firmas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8632ad4a')) {
      api.createRecord('8632ad4a', component.options)
    } else {
      api.reload('8632ad4a', component.options)
    }
    module.hot.accept("./Firmas.vue?vue&type=template&id=8632ad4a", function () {
      api.rerender('8632ad4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documento/Firmas.vue"
export default component.exports